import DataSelector from '../components/DataRuns/ControlPanel/DataSelector';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import {changeDataset,initDatasetList, 
    clearIdInfo, changeAPI, initData, changeTask, changeAPIList, initExploreMetaData, changeMode, changeExploreLoading} from '../actions';
import { StoreState } from '../types';


// 将 reducer 中的状态插入到组件的 props 中
const mapStateToProps = (state: StoreState) => ({
    dataset_id: state.dataset_id,
    datasetList: state.datasetList,
    data: state.data,
    explore_meta_data: state.explore_meta_data,
    api_id: state.api_id,
    api_id_list: state.api_id_list,
    mode_id: state.mode_id, 
    task_id: state.task_id,
})

// 将 对应action 插入到组件的 props 中
const mapDispatchToProps = (dispatch: Dispatch) => ({
    changeTask: (task_id: number| null) => dispatch(changeTask(task_id)),
    changeAPI: (api_id:number | null) => dispatch(changeAPI(api_id)),
    changeMode: (mode_id: number) => dispatch(changeMode(mode_id)),
    changeAPIList: (api_id_list:any) => dispatch(changeAPIList(api_id_list)),
    changeDataset: (dataset_id:number | null) => dispatch(changeDataset(dataset_id)),
    clearIdInfo: () => dispatch(clearIdInfo()),
    initData: (data:any) => dispatch(initData(data)),
    initExploreMetaData: (explore_meta_data: any) => dispatch(initExploreMetaData(explore_meta_data)),
    initDatasetList : (datasetList: any) => dispatch(initDatasetList(datasetList)),
    changeExploreLoading: (explore_loading: boolean) => dispatch(changeExploreLoading(explore_loading))
})

// 使用 connect 高阶组件对 Counter 进行包裹
export default connect(mapStateToProps, mapDispatchToProps)(DataSelector);
